import { Dropdown } from "@flat-ui";
import { useOnAccessLevelChange } from "@hooks/projects/use-on-access-level-change";
import { getAccessLevelItems, isProjectAccessLevel } from "@components/access-level/access-level-utils";
import { useState } from "react";
import { ChangeAccessLevelConfirmDialog } from "@components/project/change-access-level-confirm-dialog";
import { useAppSelector } from "@store/store-helper";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { SphereLabel } from "@components/common/sphere-label";

/** Access level selection component for the share snapshot or project dialog */
export function ShareDialogAccessLevel({
  type,
  isAccessLevelEditable,
  entity,
  location,
  sx
}) {
  const {
    updatingSnapshotDetails
  } = useAppSelector(fetchingProjectsFlagsSelector);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedAccessLevel, setSelectedAccessLevel] = useState();
  const [isConfirming, setIsConfirming] = useState(false);
  const {
    onAccessLevelChange
  } = useOnAccessLevelChange(type);

  // The access level dropdown options are the same for project and snapshot
  // We just need to adapt the property  for DropdownOption type
  const accessLevelItems = getAccessLevelItems(type).map(item => ({
    ...item,
    key: item.value,
    secondaryText: item.description
  }));
  function handleChange(event) {
    const newAccessLevel = event.target.value;
    if (isProjectAccessLevel(newAccessLevel)) {
      setSelectedAccessLevel(newAccessLevel);
      setIsDialogOpen(true);
    }
  }
  async function handleConfirm() {
    if (isConfirming || !selectedAccessLevel) {
      return;
    }
    setIsConfirming(true);
    try {
      // Error handling is done in the hook, so we don't need to catch errors here
      await onAccessLevelChange(selectedAccessLevel, location, entity.id);
      setIsDialogOpen(false);
    } finally {
      setIsConfirming(false);
    }
  }
  return <>
      <SphereLabel title="Access level" />
      <Dropdown disabled={!isAccessLevelEditable || updatingSnapshotDetails === "pending" || isConfirming} value={entity.accessLevel} onChange={handleChange} options={accessLevelItems} helpText={entity.accessLevel === "private" ? "Only those invited have access" : `Anyone with this link can access this ${type}`} sx={sx} />
      {selectedAccessLevel && <ChangeAccessLevelConfirmDialog type={type} accessLevel={selectedAccessLevel} isOpen={isDialogOpen} isLoading={updatingSnapshotDetails === "pending" || isConfirming} onConfirm={handleConfirm} onClose={() => setIsDialogOpen(false)} />}
    </>;
}